import React, { useState, useEffect } from "react";
import { Layout, Menu, Button, Drawer, Row, Col, Dropdown, Spin } from "antd";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import PageRoutes from "../../utils/routes";
import {
  MenuOutlined,
  SearchOutlined,
  MailOutlined,
  DownOutlined,
} from "@ant-design/icons";
import useAuth from "../../hooks/useAuth";
import FooterHome from "./Footer";
import useAuthService from "../../services/useAuthService";

const { Header, Content } = Layout;

export default function HomeLayout() {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const { personnelAuth } = useAuth();
  const { personnelLogout } = useAuthService();
  const isPersonnelLoggedIn = personnelAuth?.user;
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1300);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleDrawer = () => setDrawerVisible(!drawerVisible);
  const handleLogout = () => {
    if (personnelAuth) {
      personnelLogout.mutate();
    }
  };

  const menuItems = [
    {
      key: PageRoutes.home,
      label: <NavLink to={PageRoutes.home}>Ana Sayfa</NavLink>,
    },

    {
      key: PageRoutes.sözlesme,
      label: <NavLink to={PageRoutes.sözlesme}>Sözleşmeler</NavLink>,
    },

    ...(isPersonnelLoggedIn
      ? [
          {
            key: "advertTypes",
            label: (
              <span>
                İlanlar{" "}
                <DownOutlined style={{ fontSize: "12px", marginLeft: "4px" }} />
              </span>
            ),
            children: [
              {
                key: PageRoutes.listings,
                label: <NavLink to={PageRoutes.listings}>Tüm İlanlar</NavLink>,
              },
              {
                key: PageRoutes.favoriteAdverts,
                label: (
                  <NavLink to={PageRoutes.favoriteAdverts}>
                    Favori İlanlarım
                  </NavLink>
                ),
              },
              {
                key: PageRoutes.appliedAdverts,
                label: (
                  <NavLink to={PageRoutes.appliedAdverts}>
                    Başvurduğum İlanlar
                  </NavLink>
                ),
              },
              {
                key: PageRoutes.recommendedAdverts,
                label: (
                  <NavLink to={PageRoutes.recommendedAdverts}>
                    Bana Göre İlanlar
                  </NavLink>
                ),
              },
            ],
          },
          {
            key: PageRoutes.personnelHome,
            label: <NavLink to={PageRoutes.personnelHome}>Hesabım</NavLink>,
          },
        ]
      : []),
  ];

  const profileMenuItems = isPersonnelLoggedIn
    ? [
        {
          key: "profile",
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                padding: "16px",
                borderBottom: "1px solid #f0f0f0",
              }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "50%",
                  backgroundColor: "#6f42c1",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <span style={{ fontSize: "20px", color: "white" }}>
                  {" "}
                  {`${isPersonnelLoggedIn.name.charAt(0)}`}
                </span>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: "16px", fontWeight: 500 }}>
                  {`${isPersonnelLoggedIn.name} ${isPersonnelLoggedIn.surname}`}
                </span>
                <NavLink to={PageRoutes.personnelHome}>
                  <span style={{ color: "#6f42c1" }}>Hesabıma Git</span>
                </NavLink>
              </div>
            </div>
          ),
        },
        {
          key: "settings",
          label: (
            <NavLink
              to={PageRoutes.personnelSettings}
              style={{
                textDecoration: "none",
                color: "inherit",
                display: "block",
                padding: "12px 16px",
              }}>
              Ayarlar
            </NavLink>
          ),
        },
        {
          key: "help",
          label: (
            <NavLink
              to={PageRoutes.home}
              style={{
                textDecoration: "none",
                color: "inherit",
                display: "block",
                padding: "12px 16px",
              }}>
              Yardım
            </NavLink>
          ),
        },
        {
          key: "logout",
          label: (
            <NavLink
              to={PageRoutes.home}
              onClick={handleLogout}
              style={{
                textDecoration: "none",
                color: "inherit",
                display: "block",
                padding: "12px 16px",
              }}>
              Çıkış Yap
            </NavLink>
          ),
        },
      ]
    : [];

  const Logo = () => (
    <NavLink
      to="/"
      className="logo"
      style={{
        display: "flex",
        alignItems: "center",
        height: "100%",
      }}>
      <img
        src="/hemen_personel_icon.png"
        alt="Hemen Personel"
        style={{ height: "40px" }}
      />
    </NavLink>
  );

  const DesktopMenu = () => (
    <Menu
      mode="horizontal"
      items={menuItems}
      style={{ border: "none" }}
      subMenuOpenDelay={0.3}
      triggerSubMenuAction="hover"
    />
  );

  const MobileMenu = () => (
    <Drawer
      title={<Logo />}
      placement="left"
      onClose={toggleDrawer}
      open={drawerVisible}
      width={300}>
      <div style={{ padding: "20px 0" }}>
        <Menu mode="vertical" items={menuItems} style={{ border: "none" }} />
        {isPersonnelLoggedIn ? (
          <div style={{ marginTop: "20px" }}>
            <div
              style={{
                padding: "16px",
                backgroundColor: "#f5f5f5",
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}>
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  backgroundColor: "#6f42c1",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <span style={{ fontSize: "18px", color: "white" }}>
                  {" "}
                  {`${isPersonnelLoggedIn.name.charAt(0)}`}
                </span>
              </div>
              <span style={{ fontSize: "16px", fontWeight: 500 }}>
                {`${isPersonnelLoggedIn.name} ${isPersonnelLoggedIn.surname}`}
              </span>
            </div>
            <Menu
              mode="vertical"
              items={[
                { key: "settings", label: "Ayarlar" },
                { key: "help", label: "Yardım" },
                { key: "logout", label: "Çıkış Yap" },
              ]}
              style={{ border: "none" }}
            />
          </div>
        ) : (
          <div style={{ padding: "20px", textAlign: "center" }}>
            <Button
              onClick={() => {
                navigate(PageRoutes.authHomePage);
                setDrawerVisible(false);
              }}
              style={{ width: "100%" }}>
              Giriş Yap - Üye Ol
            </Button>
          </div>
        )}
      </div>
    </Drawer>
  );

  return (
    <Spin spinning={personnelLogout.isPending}>
      <Layout>
        <Header
          style={{
            background: "#fff",
            padding: 0,
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          }}>
          <div
            style={{
              margin: "0 auto",
              padding: isMobile ? "0 16px" : "0 32px",
              maxWidth: "1600px",
            }}>
            <Row
              align="middle"
              justify="space-between"
              style={{ height: "100%" }}>
              <Col
                style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                {isMobile && (
                  <Button
                    icon={<MenuOutlined />}
                    onClick={toggleDrawer}
                    style={{ border: "none" }}
                  />
                )}
                <Logo />
              </Col>
              {!isMobile && (
                <Col flex={1}>
                  <DesktopMenu />
                </Col>
              )}
              <Col>
                {isMobile ? (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Button
                      icon={<SearchOutlined />}
                      style={{ border: "none" }}
                    />
                    <Button
                      icon={<MailOutlined />}
                      style={{ border: "none" }}
                    />
                  </div>
                ) : isPersonnelLoggedIn ? (
                  <Dropdown
                    menu={{
                      items: profileMenuItems,
                      style: { padding: 0 },
                    }}
                    trigger={["click"]}
                    dropdownRender={(menu) => (
                      <div
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          boxShadow: "0 3px 6px rgba(0,0,0,0.16)",
                          minWidth: "240px",
                          overflow: "hidden",
                        }}>
                        {menu}
                      </div>
                    )}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        gap: "8px",
                      }}>
                      <div
                        style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          backgroundColor: "#6f42c1",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}>
                        <span style={{ fontSize: "16px", color: "white" }}>
                          {`${isPersonnelLoggedIn.name.charAt(0)}`}
                        </span>
                      </div>
                      <span style={{ fontSize: "16px" }}>
                        {" "}
                        {`${isPersonnelLoggedIn.name}`}
                      </span>
                      <DownOutlined style={{ fontSize: "12px" }} />
                    </div>
                  </Dropdown>
                ) : (
                  <Button
                    onClick={() => {
                      navigate(PageRoutes.authHomePage);
                    }}>
                    Giriş Yap - Üye Ol
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </Header>
        <MobileMenu />
        <Content
          style={{
            backgroundColor: "white",
            minHeight: "calc(100vh - 64px)",
            paddingBottom: 25,
          }}>
          <Outlet />
        </Content>
        <FooterHome></FooterHome>
      </Layout>
    </Spin>
  );
}
